/**
 * [MCV-1587] Counts the responses that block a listing delete.
 *
 * This predicate has to mirror the server's exactly. Both listing controllers
 * reject a DELETE with 409 when a listing has any `JobResponse` with
 * `deleted_flag = false` -- note that includes terminal responses (withdrawn,
 * rejected), not just live applicants. The copy shown to the user says
 * "responses" rather than "applicants" for that reason.
 *
 * Kept in one place because two features need it and a drifted copy would
 * mean offering the user a Delete the server then refuses, which is the
 * original defect.
 */
export const countOpenResponses = (listing?: {
  jobResponses?: { deletedFlag?: boolean }[];
}): number => listing?.jobResponses?.filter((response) => !response.deletedFlag).length ?? 0;
